import ApiClient from "../helpers/ApiClient";

const getSocios = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/perfil/socios`);

const getColaboradores = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores`);

const getDadosPessoais = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/${uid}/pessoais`);

const getDadosContratuais = (cnpj, uid) =>
  ApiClient.apiClientDef.get(
    `empresa/${cnpj}/colaboradores/${uid}/contratuais`
  );

const getDocumentosAtivo = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/${uid}/documentos`);

const getFeriasColaborador = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/${uid}/ferias`);

const getDadosJornadas = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/jornadas`);

const getDependentes = (cnpj, uid) =>
  ApiClient.apiClientDef.get(
    `empresa/${cnpj}/colaboradores/${uid}/dependentes`
  );

const getFerias = (cnpj, uid, feriasId) =>
  ApiClient.apiClientDef.get(
    `empresa/${cnpj}/colaboradores/${uid}/ferias/${feriasId}`
  );

const apagaDocumento = (cnpj, uid, formData) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/documentos/deletar`,
    formData
  );

const apagarFerias = (cnpj, uid, feriasId) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/${uid}/ferias/${feriasId}`
  );

const getDocumentosAdmissao = (data) =>
  ApiClient.backendClient.post(`colaboradores/Colaborador/getdocumentos`, data);

const putDadosPessoais = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/pessoais`,
    data
  );

const putDadosContratuais = (cnpj, uid, data) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/contratuais`,
    data
  );

const postDocumentosAtivo = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/documentos`,
    data
  );

const postDadosJornadas = (cnpj, data) =>
  ApiClient.apiClientDef.post(`empresa/${cnpj}/colaboradores/jornadas`, data);

const putFerias = (cnpj, uid, feriasId, data) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/ferias/${feriasId}`,
    data
  );

const solicitarAdmissao = (cnpj, uid, data, usuario) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_admissao`,
    data,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const postDependentes = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/dependentes`,
    data
  );

const deleteDependentes = (cnpj, uid, dependenteId) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/${uid}/dependentes/${dependenteId}`
  );

const putDadosJornadas = (cnpj, data, jornadaId) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/jornadas/${jornadaId}`,
    data
  );

const deleteDadosJornadas = (cnpj, jornadaId) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/jornadas/${jornadaId}`
  );

const getAtivos = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/ativos`);

const getAdmissoes = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/admissoes`);

const getDemissoes = (cnpj) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/demissoes`);

const solicitarNovaAdmissao = (cnpj, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/solicitar_admissao`,
    data
  );

const solicitarFerias = (cnpj, uid, data, usuario) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_ferias`,
    data,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const getSalarioHistorico = (cnpj, uid) =>
  ApiClient.apiClientDef.get(
    `empresa/${cnpj}/colaboradores/${uid}/historico_salario`
  );

const reajustarSalario = (cnpj, uid, data, usuario) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_reajuste`,
    data,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const putReajusteSalario = (cnpj, uid, uid_reajuste, data) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_reajuste/${uid_reajuste}`,
    data
  );

const deleteReajusteSalario = (cnpj, uid, uid_reajuste) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_reajuste/${uid_reajuste}`
  );

const getDemissao = (cnpj, uid) =>
  ApiClient.apiClientDef.get(`empresa/${cnpj}/colaboradores/${uid}/demissao`);

const solicitarDemissao = (cnpj, uid, data, usuario) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_demissao`,
    data,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const solicitarCancelamentoDemissao = (cnpj, uid, usuario) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_cancelamento_demissao`,
    null,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const cancelarDemissao = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/${uid}/cancelar_demissao`
  );

const aprovarDemissao = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/aprovar_demissao`,
    data
  );

const aprovarAdmissao = (cnpj, uid, data) =>
  ApiClient.apiClientDef.post(
    `empresa/${cnpj}/colaboradores/${uid}/aprovar_admissao`,
    data
  );

const solicitarCancelamentoAdmissao = (cnpj, uid, usuario) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/solicitar_cancelamento_admissao`,
    null,
    {
      headers: {
        usuario: usuario,
      },
    }
  );

const cancelarAdmissao = (cnpj, uid) =>
  ApiClient.apiClientDef.delete(
    `empresa/${cnpj}/colaboradores/${uid}/cancelar_admissao`
  );

const aprovarReajuste = (cnpj, uid, uid_reajuste) =>
  ApiClient.apiClientDef.put(
    `empresa/${cnpj}/colaboradores/${uid}/aprovar_reajuste/${uid_reajuste}`
  );

const ColaboradoresApiClient = {
  getSocios,
  getColaboradores,
  getDadosPessoais,
  getDocumentosAtivo,
  getFerias,
  getDadosContratuais,
  getDadosJornadas,
  getDependentes,
  getFeriasColaborador,
  apagaDocumento,
  apagarFerias,
  getDocumentosAdmissao,
  putDadosPessoais,
  putDadosContratuais,
  postDocumentosAtivo,
  postDadosJornadas,
  putFerias,
  solicitarAdmissao,
  postDependentes,
  deleteDependentes,
  putDadosJornadas,
  deleteDadosJornadas,
  getAtivos,
  getAdmissoes,
  getDemissoes,
  solicitarNovaAdmissao,
  solicitarFerias,
  reajustarSalario,
  getSalarioHistorico,
  putReajusteSalario,
  deleteReajusteSalario,
  getDemissao,
  solicitarDemissao,
  cancelarDemissao,
  solicitarCancelamentoDemissao,
  aprovarDemissao,
  aprovarAdmissao,
  solicitarCancelamentoAdmissao,
  cancelarAdmissao,
  aprovarReajuste,
};

export default ColaboradoresApiClient;
